/*
 * @Author: your name
 * @Date: 2020-09-19 11:21:58
 * @LastEditTime: 2024-01-26 16:54:56
 * @LastEditors: betwaym 848032671@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_admin\src\service\api\login.js
 */

import http from "../httpConfig"
import {auth} from "@/utils/sso"
// 获取rsa公钥
export const getKey = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/rsa/getKey/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 登录接口  带了版本的就是加密的 ，不带版本就是不加密的
export const login = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/login/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
//登出接口
export const loginOut = (params = {}) => {
  auth.logout()
  // return new Promise((resolve, reject) => {
  //   http
  //     .post("/logout/v1", params)
  //     .then((res) => {
  //       resolve(res)
  //     })
  //     .catch((err) => {
  //       reject(err)
  //     })
  // })
}

//切换公司 掉接口传给公司
// export const switchCompany = (params = {}) => {
//   return new Promise((resolve, reject) => {
//     http.post('/api/company/switch-company/v1', params)
//       .then(res => {
//         resolve(res)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

//切换公司 掉接口传给公司
export const switchCompany = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("update-user-info/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export const getMenu = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/menu/list-user-menus/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
